import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import { ClientsWorkingPointsDataInterface } from "../../../../redux/interfaces/expedition.interface";

const statusesTypes = [
  { value: 0, label: "Nevalidat" },
  { value: 1, label: "Validat" },
  { value: 2, label: "Modificare date" },
  { value: 3, label: "Confirmare date la client" },
];

const getStatusLabel = (status: number) => {
  const getStatus = statusesTypes.find((item) => item.value === status);
  return getStatus ? getStatus.label : "";
};

export const clientsWorkingPointsTableHeader: TableHeaderCategoryConfig[] = [
  {
    value: "Id punct lucru",
    minW: 125,
  },
  {
    label: "Localitate",
    value: "localitate",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Judet",
    value: "judet",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Adresa",
    value: "adresa",
    withSearch: true,
    minW: 125,
  },
  {
    value: "Persoana contact",
    minW: 125,
  },
  {
    value: "Telefon",
    minW: 125,
  },
  {
    value: "deliveryPoint",
    label: "Punct de livrare/asociat",
    withSearch: { placeholder: "Punct de livrare" },
    minW: 125,
  },
  {
    label: "Asociere",
    value: "validat",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
  },
];

export const getClientsWorkingPointsTableData: any = (
  data: ClientsWorkingPointsDataInterface[],
) =>
  data?.map((item) => {
    const associatedDeliveryPoint = item.id_punctlucru;

    const getTitleColor = () => {
      if (!associatedDeliveryPoint) {
        return "red";
      }
      return "black";
    };

    return {
      id: item.idPctLucru,
      crudData: item,
      data: [
        {
          title: item.idPctLucru,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.localitate,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.judet,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.adresa,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.persContact,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.telContact,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          badges: [
            {
              badgeText: item.pctDeLivrare,
              badgeColor: !associatedDeliveryPoint
                ? "light-danger"
                : "light-info",
            },
            {
              badgeText: item.pctDeLivrareAsociat ?? "-",
              badgeColor: !associatedDeliveryPoint
                ? "light-danger"
                : "light-success",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.asociat === 1 ? "Asociat" : "Neasociat",
              badgeColor: associatedDeliveryPoint
                ? "light-success"
                : "light-danger",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: getStatusLabel(item.status),
              badgeColor: associatedDeliveryPoint
                ? "light-success"
                : "light-danger",
            },
          ],
        },
      ],
    };
  });
